import axios from "axios/dist/browser/axios.cjs";

export async function rpc(fn, payload, meta = {}) {
  const functionsUrl = window.location.host.includes("epistle.test") ? "http://functions.epistle.test:9124" : "https://functions.epistle.org";
  const { data } = await axios.post(`${functionsUrl}/rpc/${fn}`, {
    fn,
    payload,
    ...meta
  }, { withCredentials: true });

  if (data.success === true) return data.payload;
  const err = new Error(data.error.message);
  err.stack = data.error.stack;
  err.code = data.error.code;
  err.name = data.error.name;
  throw err;
}
